// extracted by mini-css-extract-plugin
export default {"container":"Delete_container__2VU7G","progressContainer":"Delete_progressContainer__UTiJi"};